export class Model {
  attributes = {};

  embeds = {};

  links = {};

  meta = {};

  constructor(attributes = {}) {
    this.attributes = { ...attributes };

    if (typeof this.attributes._embedded !== 'undefined') {
      this.embeds = this.attributes._embedded;
      delete this.attributes._embedded;
    }

    if (typeof this.attributes._links !== 'undefined' && Array.isArray(this.attributes._links)) {
      this.attributes._links.forEach(link => {
        this.links[link.rel] = link.href;
      });
      delete this.attributes._links;
    }

    if (typeof this.attributes._links !== 'undefined' && Array.isArray(this.attributes._links)) {
      this.attributes._links.forEach(link => {
        this.links[link.rel] = link.href;
      });
      delete this.attributes._links;
    }
  }

  get id() {
    return this.attributes.id;
  }

  /**
   * @param {Model} model
   */
  update(model) {
    model.attributes.forEach(attribute => {
      this.attributes[attribute] = model.attributes[attribute];
    });
  }

  /**
   * @param {string} link
   * @return {string|null}
   */
  getLink(link) {
    return this.links[link] || null;
  }

  serialize() {
    return JSON.stringify(this.attributes);
  }

  static unserialize(data) {
    return new this(JSON.parse(data));
  }
}
